module.exports = store

function store (state, emitter) {
  state.numberInput = 0
  state.categories = require('../categories.json')
  state.input = state.categories.shower
  state.output = state.categories.shower

  emitter.on('DOMContentLoaded', () => {
    emitter.on('updateState', (cb) => {
      let inputValue = document.querySelector('#numberInput').value
      if (inputValue && parseInt(inputValue)) {
        let numInput = parseInt(inputValue)
        state.numberInput = numInput
        if (numInput > 1000) {
          window.alert('Unable to render more than 1000 items!')
        } else {
          let inputKey = document.querySelector('#inputCategory').value
          let outputKey = document.querySelector('#outputCategory').value
          state.input = state.categories[inputKey]
          state.output = state.categories[outputKey]
        }
      }
      cb()
    })
  })
}
